import { mapToCanActivate, Routes } from '@angular/router';
import { AuthGuard } from '@next/core-lib/authorization';

import { ContactpersonAuthorizationsComponent } from './components/contactperson-authorizations/contactperson-authorizations.component';
import { ContactpersonDetailComponent } from './components/contactperson-detail/contactperson-detail.component';
import { ContactpersonItemComponent } from './components/contactperson-item/contactperson-item.component';
import { ContactpersonOverviewComponent } from './components/contactperson-overview/contactperson-overview.component';
import { RelationsLocationDetailComponent } from './components/contactperson-relations/relations-location-detail/relations-location-detail.component';
import { RelationsOverviewComponent } from './components/contactperson-relations/relations-overview/relations-overview.component';
import { ContactpersonComponent } from './contactperson.component';
import { ContactpersonsGuard } from './guards/contactpersons.guard';

const routes: Routes = [
  {
    path: '',
    component: ContactpersonOverviewComponent,
    canActivate: mapToCanActivate([ContactpersonsGuard]),
    data: { name: 'contactperson-overview', pageTitle: 'app.contactperson.module' },
  },
  {
    path: ':contactpersonId',
    component: ContactpersonItemComponent,
    canActivate: mapToCanActivate([ContactpersonsGuard]),
    children: [
      {
        path: '',
        component: ContactpersonDetailComponent,
        data: { name: 'contactperson-detail' },
      },
      {
        path: 'authorizations',
        component: ContactpersonAuthorizationsComponent,
        data: { name: 'contactperson-authorizations' },
      },
      {
        path: 'relations',
        component: RelationsOverviewComponent,
        data: { name: 'contactperson-relations' },
      },
    ],
  },
  {
    path: ':contactpersonId/relations/:customerId',
    component: RelationsLocationDetailComponent,
    data: { name: 'contactperson-relations-detail' },
  },
];

export const contactpersonRoutes: Routes = [
  { path: '', redirectTo: 'contactperson', pathMatch: 'full' },
  {
    path: 'contactperson',
    component: ContactpersonComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    children: routes,
  },
];
